import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Menu } from 'antd';
import {
  HiOutlineBuildingStorefront,
  HiOutlineDocumentText,
  HiOutlineShoppingCart,
  HiUserGroup,
} from 'react-icons/hi2';
import { ImProfile } from 'react-icons/im';
import {
  AppstoreOutlined,
  DesktopOutlined,
  MailOutlined,
  PieChartOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { FiBarChart2 } from 'react-icons/fi';
import { HiDocumentReport } from 'react-icons/hi';
import { TbFileInvoice, TbReportSearch, TbRulerMeasure } from 'react-icons/tb';
import { CiShoppingBasket } from 'react-icons/ci';
import { LuBaggageClaim, LuClipboardType } from 'react-icons/lu';
import { PiBatteryVerticalLow } from 'react-icons/pi';
import {
  RiAlignItemBottomFill,
  RiBankFill,
  RiPriceTag2Fill,
  RiShieldUserFill,
  RiShoppingBag4Fill,
} from 'react-icons/ri';
import {
  MdAccountBalanceWallet,
  MdAssignmentAdd,
  MdAttachMoney,
  MdInventory,
  MdLocalFireDepartment,
  MdManageAccounts,
  MdOutlineAssignment,
  MdOutlineDataThresholding,
  MdOutlineFlourescent,
  MdOutlineHolidayVillage,
  MdOutlinePolicy,
  MdOutlinePriceChange,
  MdOutlineReceiptLong,
  MdPayment,
  MdPriceChange,
  MdSettingsApplications,
  MdSpeakerNotes,
  MdSpoke,
  MdWork,
} from 'react-icons/md';
import {
  FaCalendarCheck,
  FaAddressCard,
  FaFileInvoice,
  FaMoneyBillWave,
  FaCalendarAlt,
  FaDiagnoses,
  FaBusinessTime,
  FaLaptopMedical,
  FaCodeBranch,
  FaMoneyCheckAlt,
  FaChartLine,
  FaUsers,
  FaCartPlus,
  FaClipboardList,
} from 'react-icons/fa';
import {
  FaServer,
  FaCartFlatbed,
  FaTooth,
  FaTableList,
  FaMoneyBills,
  FaMoneyBillTrendUp,
  FaReceipt,
  FaMoneyBillTransfer,
  FaMoneyBillWheat,
} from 'react-icons/fa6';
import { GrServices } from 'react-icons/gr';
import {
  SiGoogleanalytics,
  SiKnowledgebase,
  SiSpeedtest,
} from 'react-icons/si';
import { Link, useNavigate } from 'react-router-dom';

// import logo from '../assets/labeaute.png';
// import logo2 from '../assets/labeaute2.png';
import logo from '../assets/logoNew.png';
import logo2 from '../assets/logoNew (1).png';
// import logo from '../assets/logo.png';
import { IoIosCash, IoIosJournal, IoMdWallet } from 'react-icons/io';
import {
  IoBody,
  IoGitCompare,
  IoLocationSharp,
  IoPieChart,
} from 'react-icons/io5';
import {
  AiFillMedicineBox,
  AiOutlineBarChart,
  AiOutlineFileProtect,
  AiOutlineReconciliation,
  AiOutlineSchedule,
  AiOutlineStock,
} from 'react-icons/ai';
import {
  GiFiles,
  GiLevelThreeAdvanced,
  GiMoneyStack,
  GiProfit,
  GiReceiveMoney,
  GiReturnArrow,
} from 'react-icons/gi';
const Sidebar = ({ collapsed }) => {
  const { currentLang } = useSelector((state) => state.user);
  const [stateOpenKeys, setStateOpenKeys] = useState([]);

  const navigate = useNavigate();
  const items = [
    {
      key: 'sub3-driv',
      label: (
        <h3 className="text-[14px] h-[32px] font-semibold text-[#919da9]">
          {currentLang === 'en' ? 'MENU' : 'مينو'}
        </h3>
      ),
    },
    {
      key: 'sub3-d',
      label: currentLang === 'en' ? 'Dashboard' : 'لوحة البيانات',
      icon: <AppstoreOutlined />,
      path: '/',
    },
    {
      key: 'sub3',
      label: currentLang === 'en' ? 'Sales & Finance' : 'الفواتير و الحسابات',
      icon: <AppstoreOutlined />,
      children: [
        {
          key: 'sub8-1',
          label: currentLang === 'en' ? 'Customers' : 'العملاء',
          icon: <FaUsers />,
          path: '/customers',
        },
        {
          key: 'sub8-2',
          label: currentLang === 'en' ? 'Sales Order' : 'طلبات المبيعات',
          icon: <FaCartPlus />,
          path: '/sales-order',
        },
        {
          key: '17',
          label: currentLang === 'en' ? 'Sales Invoice' : 'الفواتير',
          icon: <FaFileInvoice />,
          path: '/sales-invoice',
        },
        {
          key: '17-1',
          label: currentLang === 'en' ? 'Credit Notes' : 'اشعار دائن',
          icon: <FaMoneyBillTrendUp />,
          path: '/credit-notes',
        },
        {
          key: '181',
          label: currentLang === 'en' ? 'Receipt Voucher' : 'سند قبض',
          icon: <FaMoneyBillWave />,
          path: '/receipt-voucher',
        },
        {
          key: '19',
          label: currentLang === 'en' ? 'Journal Entry' : 'القيود اليوميه',
          icon: <IoIosJournal />,
          path: '/journal-entry',
        },
        {
          key: '21',
          label: currentLang === 'en' ? 'Chart of Accounts' : 'شجرة الحسابات',
          icon: <IoPieChart />,
          path: '/accounts',
        },
        {
          key: '37',
          label:
            currentLang === 'en' ? 'Payment Reconciliation' : 'تسوية المدفوعات',
          icon: <IoGitCompare />,
          path: '/reconcillation',
        },

        {
          key: 'sub4',
          label: currentLang === 'en' ? 'Setting' : 'اعدادات',
          icon: <SettingOutlined />,
          className: 'show-path-name',
          children: [
            // {
            //   key: '28',
            //   label: currentLang === 'en' ? 'Collection Method' : 'طرق السداد',
            //   icon: <RiShoppingBag4Fill />,
            //   path: '/bnpi',
            // },
            {
              key: '23',
              label: currentLang === 'en' ? 'Fiscal Year' : 'السنة المالية',
              icon: <FaCalendarAlt />,
              path: '/fiscalyear',
            },
            {
              key: '25-1',
              label: currentLang === 'en' ? 'Account Period' : 'فترة محاسبيه',
              icon: <MdAccountBalanceWallet />,
              path: '/account-period',
            },
            {
              key: '22',
              label: currentLang === 'en' ? 'Mode of Payment' : 'طريقة الدفع',
              icon: <MdPayment />,
              path: '/modeofpayments',
            },
            {
              key: '24',
              label: currentLang === 'en' ? 'Cost Center' : 'مركز التكلفة',
              icon: <FaMoneyBills />,
              path: '/costcenter',
            },
            {
              key: '36',
              label: currentLang === 'en' ? 'Bank' : 'البنوك',
              icon: <RiBankFill />,
              path: '/bank',
            },
            {
              key: '38',
              label: currentLang === 'en' ? 'Bank Account' : 'الحسابات البنكيه',
              icon: <MdAccountBalanceWallet />,
              path: '/bank-account',
            },
            {
              key: '39',
              label:
                currentLang === 'en'
                  ? 'Cost Center Allocation'
                  : ' مركز التكلفة المجمع',
              icon: <MdOutlineFlourescent />,
              path: '/cost-center-allocation',
            },
            {
              key: '39-1',
              label: currentLang === 'en' ? 'Address' : 'عناوين العملاء',
              icon: <IoLocationSharp />,
              path: '/address',
            },
            {
              key: '69',
              label: currentLang === 'en' ? 'Branch' : 'فرع',
              icon: <FaCodeBranch />,
              path: '/Branch-hr',
            },
          ],
        },
        {
          key: 'sub4-r',
          label: currentLang === 'en' ? 'Reports' : 'التقارير',
          icon: <TbReportSearch />,
          className: 'show-path-name',
          children: [
            {
              key: '100',
              label: (
                <span className="menu-item-label">
                  {currentLang ? 'Trial Balance' : 'ميزان المراجعة'}
                </span>
              ),
              icon: <HiDocumentReport />,
              path: '/Trial-Balance',
            },
            {
              key: '100-pl',
              label: (
                <span className="menu-item-label">
                  {currentLang ? 'Profit And Loss' : 'الارباح و الخسائر'}
                </span>
              ),
              icon: <GiProfit />,
              path: '/profit-loss',
            },
            {
              key: '10-cf',
              label: (
                <span className="menu-item-label">
                  {currentLang ? 'Cash Flow' : 'التدفقات النقديه'}
                </span>
              ),
              icon: <FaMoneyBillWave />,
              path: '/cash-flow',
            },
            {
              key: '101-bs',
              label: (
                <span className="menu-item-label">
                  {currentLang ? 'Balance Sheet' : 'الميزانيه العموميه'}
                </span>
              ),
              icon: <FiBarChart2 />,
              path: '/balance-sheet',
            },
            {
              key: '101-cfs',
              label: (
                <span className="menu-item-label">
                  {currentLang
                    ? 'Consolidated Financial Statement'
                    : 'القوائم الماليه'}
                </span>
              ),
              icon: <MdAttachMoney />,
              path: '/consolidated-financial-statement',
            },
            {
              key: '683',
              label: (
                <span className="menu-item-label">
                  {currentLang === 'en'
                    ? 'General Ledger'
                    : 'دفتر الاستاذ العام'}
                </span>
              ),
              icon: <GiFiles />,
              path: '/general-ledger-report',
            },
            {
              key: '100-rs',
              label: (
                <span className="menu-item-label">
                  {currentLang
                    ? 'Accounts Receivable Summary'
                    : 'ملخص الحسابات المستحقة'}
                </span>
              ),
              icon: <IoMdWallet />,
              path: '/accounts-receivable-summary',
            },
            {
              key: '102-ps',
              label: (
                <span className="menu-item-label">
                  {currentLang
                    ? 'Accounts Payable Summary'
                    : 'ملخص الحسابات المدينه'}
                </span>
              ),
              icon: <IoIosCash />,
              path: '/accounts-payable-summary',
            },
            {
              key: '142-sa',
              label: (
                <span className="menu-item-label">
                  {currentLang ? 'Statement 0f Account' : 'كشف حساب'}
                </span>
              ),
              icon: <MdAccountBalanceWallet />,
              path: '/statement-of-account',
            },
            {
              key: '142-1-sa',
              label: (
                <span className="menu-item-label">
                  {currentLang
                    ? 'Zatca Details Report'
                    : 'تقرير تفاصيل هيئه الزكاه'}
                </span>
              ),
              icon: <IoIosCash />,
              path: '/Zatca-Details-Report',
            },
            {
              key: '142-2-sa',
              label: (
                <span className="menu-item-label">
                  {currentLang
                    ? 'Zatca Summary Report'
                    : 'تقرير ملخص هيئه الزكاه'}
                </span>
              ),
              icon: <IoIosCash />,
              path: '/Zatca-Summary-Report',
            },
          ],
        },
      ],
    },
    {
      key: 'sub5',
      label:
        currentLang === 'en'
          ? 'Inventory & Purchasing '
          : 'المستودع و المشتريات',
      icon: <MdInventory />,
      children: [
        {
          key: '41',
          label: currentLang === 'en' ? 'Supplier' : 'الموردين',
          icon: <HiUserGroup />,
          path: '/supplier',
        },

        {
          key: '43',
          label: currentLang === 'en' ? 'Material Request' : 'طلب المواد',
          icon: <HiOutlineDocumentText />,
          path: '/material-request',
        },
        {
          key: '44',
          label: currentLang === 'en' ? 'Purchase Order' : 'طلب الشراء',
          icon: <CiShoppingBasket />,
          path: '/purchase-order',
        },
        {
          key: '45',
          label: currentLang === 'en' ? 'Purchase Receipt' : 'استلام مشتريات',
          icon: <MdOutlineReceiptLong />,
          path: '/purchase-receipt',
        },
        {
          key: '46',
          label: currentLang === 'en' ? 'Purchase Invoice' : 'فاتورة مشتريات',
          icon: <TbFileInvoice />,
          path: '/purchase-invoice',
        },
        {
          key: '451',
          label: currentLang === 'en' ? 'Purchase Return' : 'ارجاع مشتريات',
          icon: <GiReturnArrow />,
          path: '/purchase-return',
        },
        {
          key: '434',
          label: currentLang === 'en' ? 'Debit Note' : 'اشعار مدين',
          icon: <GiReceiveMoney />,
          path: '/debit-note',
        },
        {
          key: '1811',
          label: currentLang === 'en' ? 'Payment Voucher' : 'سند دفع',
          icon: <FaMoneyBillWave />,
          path: '/payment-voucher',
        },

        {
          key: '48',
          label: currentLang === 'en' ? 'Item' : 'الصنف',
          icon: <RiAlignItemBottomFill />,
          path: '/item-list',
        },

        {
          key: '51',
          label:
            currentLang === 'en' ? 'Stock Reconcillation' : 'تسوية المخزون',
          icon: <AiOutlineReconciliation />,
          path: '/stock-reconcillation',
        },
        {
          key: '52',
          label: currentLang === 'en' ? 'Stock Entry' : 'حركه مخزون',
          icon: <MdInventory />,
          path: '/stock-entry',
        },
        {
          key: '61',
          label:
            currentLang === 'en'
              ? 'Landed Cost Voucher'
              : 'تكاليف الشحن و التفريغ',
          icon: <FaReceipt />,
          path: '/landed-cost-voucher',
        },
        {
          key: 'sub44-is',
          label: currentLang === 'en' ? 'Setting' : 'اعدادات',
          icon: <SettingOutlined />,
          className: 'show-path-name',
          children: [
            {
              key: '4044',
              label:
                currentLang === 'en' ? 'Supplier Group' : 'مجموعة الموردين',
              // icon: <HiUserGroup  />,
              icon: <HiOutlineShoppingCart />,
              path: '/supplier-group',
            },
            {
              key: '40',
              label: currentLang === 'en' ? 'Item Group' : 'مجموعة الاصناف',
              // icon: <HiUserGroup  />,
              icon: <HiOutlineShoppingCart />,
              path: '/item-group',
            },
            {
              key: '42',
              label: currentLang === 'en' ? 'Warehouse' : 'المستودعات',
              icon: <HiOutlineBuildingStorefront />,
              path: '/warehouse',
            },
            {
              key: '47',
              label: currentLang === 'en' ? 'Price List' : 'قائمة الاسعار',
              icon: <MdPriceChange />,
              path: '/price-list',
            },
            {
              key: '49',
              label: currentLang === 'en' ? 'Item Price' : 'سعر الصنف',
              icon: <RiPriceTag2Fill />,
              path: '/item-price',
            },
            {
              key: '50',
              label: currentLang === 'en' ? 'Unit Measure' : 'وحدات القياس',
              icon: <TbRulerMeasure />,
              path: '/unit-measure',
            },
          ],
        },
        {
          key: 'sub4-r',
          label: currentLang === 'en' ? 'Reports' : 'التقارير',
          icon: <TbReportSearch />,
          className: 'show-path-name',
          children: [
            {
              key: '681',
              label:
                currentLang === 'en'
                  ? 'Stock Balance Report'
                  : 'تقرير حركة المخزون',
              icon: <AiOutlineBarChart />,
              path: '/stock-balance-report',
            },
            {
              key: '682',
              label:
                currentLang === 'en'
                  ? 'Stock Ledger Report'
                  : 'تقرير سجل المخزون',
              icon: <FaClipboardList />,
              path: '/stock-ledger-report',
            },
            {
              key: 'sub4-1',
              label: currentLang === 'en' ? 'Item Price' : 'سعر الصنف',
              icon: <MdOutlinePriceChange />,
              path: '/item-price-report',
            },
            {
              key: 'sub4-2',
              label: currentLang === 'en' ? 'Stock Analysis' : 'تحليل المخزون',
              icon: <AiOutlineStock />,
              path: '/stock-analysis-report',
            },
            {
              key: 'sub4-3',
              label:
                currentLang === 'en' ? 'Purchase Analytics' : 'تحليل الشراء',
              icon: <SiGoogleanalytics />,
              path: '/purchase-analytics-report',
            },
          ],
        },
      ],
    },
    {
      key: 'sub7',
      label: currentLang === 'en' ? 'HR' : 'الموارد البشرية',
      icon: <MdOutlineDataThresholding />,
      children: [
        {
          key: '53',
          label: currentLang === 'en' ? 'Employee' : 'الموظفين',
          icon: <HiUserGroup />,
          path: '/employee',
        },
        {
          key: '533',
          label: currentLang === 'en' ? 'Attandence' : 'الحضور والغياب',
          icon: <MdSpeakerNotes />,
          path: '/attandence',
        },
        {
          key: '54',
          label: currentLang === 'en' ? 'Leave Management' : 'ادارة الاجازات',
          icon: <MdManageAccounts />,
          className: 'show-path-name',
          children: [
            {
              key: '55',
              label: currentLang === 'en' ? 'Leave Type' : 'نوع الاجازة',
              icon: <LuClipboardType />,
              path: '/leave-type',
            },
            {
              key: '56',
              label: currentLang === 'en' ? 'Leave Policy' : 'سياسة الاجازة',
              icon: <MdOutlinePolicy />,
              path: '/leave-policy',
            },
            {
              key: '57',
              label:
                currentLang === 'en' ? 'Leave allocation' : 'تخصيص الاجازة',
              icon: <PiBatteryVerticalLow />,
              path: '/leave-allocation',
            },
            {
              key: '58',
              label:
                currentLang === 'en'
                  ? 'Leave Policy Assign'
                  : 'تخصيص سياسة الاجازة',
              icon: <MdOutlineAssignment />,
              path: '/leave-policy-assign',
            },
            {
              key: '59',
              label: currentLang === 'en' ? 'Leave Application' : 'طلب الاجازة',
              icon: <MdSettingsApplications />,
              path: '/leave-application',
            },
            {
              key: '60',
              label: currentLang === 'en' ? 'Holiday List' : 'قائمة العطلات',
              icon: <MdOutlineHolidayVillage />,
              path: '/holiday-list',
            },
          ],
        },
        {
          key: '62',
          label: currentLang === 'en' ? 'Finance' : 'المالية',
          icon: <RiPriceTag2Fill />,
          className: 'show-path-name',
          children: [
            {
              key: '63',
              label:
                currentLang === 'en'
                  ? 'Expense Claim type'
                  : 'نوع مطالبة المصروفات',
              icon: <LuBaggageClaim />,
              path: '/expense-claim-type',
            },
            {
              key: '64',
              label:
                currentLang === 'en' ? 'Employee Advance' : 'الموظفين المقدمين',
              icon: <GiLevelThreeAdvanced />,
              path: '/employee-advance',
            },
            {
              key: '65',
              label:
                currentLang === 'en' ? 'Additional Salay' : 'الراتب الاضافي',
              icon: <FaMoneyBillTrendUp />,
              path: '/additional-salay',
            },
            {
              key: '651',
              label:
                currentLang === 'en' ? 'Expense Claim' : 'مطالبة المصروفات',
              icon: <FaMoneyBillTrendUp />,
              path: '/expense-claim',
            },
          ],
        },
        {
          key: '66',
          label: currentLang === 'en' ? 'Setting' : 'اعدادات',
          icon: <SettingOutlined />,
          className: 'show-path-name',
          children: [
            {
              key: '67',
              label: currentLang === 'en' ? 'Department' : 'قسم',
              icon: <MdLocalFireDepartment />,
              path: '/department-hr',
            },
            {
              key: '68',
              label: currentLang === 'en' ? 'Designation' : 'التعيين',
              icon: <MdWork />,
              path: '/designation-hr',
            },
            // {
            //   key: '69',
            //   label: currentLang === 'en' ? 'Branch' : 'فرع',
            //   icon: <FaCodeBranch />,
            //   path: '/Branch-hr',
            // },
          ],
        },
        {
          key: '70',
          label: currentLang === 'en' ? 'Payroll' : 'الرواتب',
          icon: <GiMoneyStack />,
          className: 'show-path-name',
          children: [
            {
              key: '71',
              label: currentLang === 'en' ? 'Salary Component' : 'مكون الراتب',
              icon: <FaMoneyBillWheat />,
              path: '/salary-component-hr',
            },
            {
              key: '72',
              label:
                currentLang === 'en' ? 'Salary Structure' : 'منظومة الرواتب',
              icon: <FaMoneyBills />,
              path: '/salary-structure-hr',
            },
            {
              key: '73',
              label:
                currentLang === 'en'
                  ? 'Salary Structure Assignment'
                  : 'تخصيص منظومة الرواتب',
              icon: <FaMoneyBillTransfer />,
              path: '/salary-structure-assign-hr',
            },
            {
              key: '731',
              label: currentLang === 'en' ? 'Salary Slip' : 'قسيمة الرواتب',
              icon: <FaMoneyCheckAlt />,
              path: '/salary-slip-hr',
            },
            {
              key: '732',
              label: currentLang === 'en' ? 'Payroll Entry' : 'دخول الرواتب',
              icon: <MdAssignmentAdd />,
              path: '/payroll-entry-hr',
            },
          ],
        },
      ],
    },
    {
      key: 'sub78',
      label: currentLang === 'en' ? 'Profile' : 'الملف الشخصي',
      icon: <ImProfile />,
      path: '/profile',
    },
  ];
  const getLevelKeys = (items1) => {
    const key = {};
    const func = (items2, level = 1) => {
      items2.forEach((item) => {
        if (item.key) {
          key[item.key] = level;
        }
        if (item.children) {
          func(item.children, level + 1);
        }
      });
    };
    func(items1);
    return key;
  };
  const levelKeys = getLevelKeys(items);
  const onOpenChange = (openKeys) => {
    const currentOpenKey = openKeys.find(
      (key) => stateOpenKeys.indexOf(key) === -1
    );
    // open
    if (currentOpenKey !== undefined) {
      const repeatIndex = openKeys
        .filter((key) => key !== currentOpenKey)
        .findIndex((key) => levelKeys[key] === levelKeys[currentOpenKey]);

      setStateOpenKeys(
        openKeys
          // remove repeat key
          .filter((_, index) => index !== repeatIndex)
          // remove current level all child
          .filter((key) => levelKeys[key] <= levelKeys[currentOpenKey])
      );
    } else {
      // close
      setStateOpenKeys(openKeys);
    }
  };
  const handleClick = (e) => {
    navigate(e.item.props.path);
  };
  return (
    <div className="main-sidebar">
      <div
        style={{
          height: '100%',
        }}
      >
        <div className="logo-wrapper">
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              // padding: '5px 0px 15px ',
              padding: '10px 0px 0px ',
            }}
          >
            <Link href={`/dashboard`}>
              {collapsed ? (
                <img
                  src={logo2}
                  className="mobile-logo logo-1"
                  alt="logo"
                  style={{
                    // width: 220,
                    maxWidth: 40,
                    borderBottom: '1px solid #cccccc8b',
                    paddingBottom: 10,
                  }}
                />
              ) : (
                <img
                  src={logo}
                  className="mobile-logo logo-1"
                  alt="logo"
                  style={{
                    maxWidth: 200,
                    borderBottom: '1px solid #cccccc8b',
                    paddingBottom: 10,
                    height: 50,
                    // objectFit: 'cover',
                  }}
                />
              )}
              {/* <img
                src={logoTwo}
                alt="logo"
                className="w-[100px] h-[50px] object-contain"
              /> */}
            </Link>
          </div>
        </div>
        <Menu
          mode="inline"
          // theme="dark"
          // multiple={false}
          items={items}
          onClick={handleClick}
          style={{
            background: 'transparent',
          }}
          openKeys={stateOpenKeys}
          onOpenChange={onOpenChange}
          defaultSelectedKeys={[
            window.location.pathname === '/'
              ? ''
              : window.location.pathname.split('/')[1],
          ]}
          // defaultOpenKeys={['sub1', 'sub3', 'sub5']}
          // onClick={({ key }) => {
          //   console.log('getItem  key:', key);
          //   navigate('/' + key);
          // }}
        />
      </div>
    </div>
  );
};

export default Sidebar;
